import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { ChevronLeft } from 'lucide-react'

interface Props {
  onClick?: () => void
}

export const BackButton: React.FC<Props> = (props) => {
  const navigate = useNavigate()
  const { onClick = () => navigate(-1) } = props

  return (
    <Button type='button' variant='ghost' onClick={onClick}>
      <ChevronLeft />
    </Button>
  )
}
